// Minimal fetch wrapper that injects the Bearer token from auth context.
// VITE_API_BASE is baked at build time; default to same-origin so one
// image serves multiple envs (axon cutover guard).

const BASE = (import.meta.env.VITE_API_BASE as string | undefined) ?? "";

export type ApiError = {
  status: number;
  message: string;
};

export async function api(
  path: string,
  opts: RequestInit & { token?: string | null } = {},
): Promise<Response> {
  const { token, headers, ...rest } = opts;
  const h: Record<string, string> = {
    Accept: "application/json",
    ...(headers as Record<string, string>),
  };
  if (token) h.Authorization = `Bearer ${token}`;
  if (rest.body && !h["Content-Type"]) h["Content-Type"] = "application/json";
  const res = await fetch(`${BASE}${path}`, { ...rest, headers: h });
  return res;
}

export async function apiJSON<T>(path: string, opts: RequestInit & { token?: string | null } = {}): Promise<T> {
  const res = await api(path, opts);
  if (!res.ok) {
    const message = await res.text().catch(() => res.statusText);
    const e: ApiError = { status: res.status, message: message || res.statusText };
    throw e;
  }
  return (await res.json()) as T;
}
